module.exports = __webpack_public_path__ + "media/images/prev-f21674fcad296a68c01766330c88cdfe.png";